import {
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { Platform } from '@ionic/angular';

@Directive({
  selector: '[appIosWebTouchDetect]',
  standalone: true,
})
export class IosWebTouchDetectDirective implements OnInit, OnDestroy {
  @HostListener('touchstart', ['$event'])
  onTouchstart(): void {
    if (this.isIosWeb) {
      this.renderer.addClass(this.el.nativeElement, this.touchedClassName);
    }
  }

  @HostListener('touchend', ['$event'])
  onTouchend(): void {
    if (this.isIosWeb) {
      this.touchendTimer = setTimeout(() => {
        this.renderer.removeClass(this.el.nativeElement, this.touchedClassName);
      }, 2000);
    }
  }

  @HostListener('touchcancel', ['$event'])
  onTouchcancel(): void {
    if (this.isIosWeb) {
      this.touchcancelTimer = setTimeout(() => {
        this.renderer.removeClass(this.el.nativeElement, this.touchedClassName);
      }, 2000);
    }
  }

  private isIosWeb = false;
  private touchcancelTimer: null | ReturnType<typeof setTimeout> = null;
  private touchendTimer: null | ReturnType<typeof setTimeout> = null;
  private readonly touchedClassName = 'ios-web-ele-touched';
  private readonly notIosWebClassName = 'not-ios-web';

  constructor(
    private el: ElementRef,
    private platform: Platform,
    private renderer: Renderer2
  ) {
    const isMobileWeb = this.platform.is('mobileweb');
    const isIOS = this.platform.is('ios');
    this.isIosWeb = isMobileWeb && isIOS;
  }

  ngOnInit() {
    if (!this.isIosWeb) {
      this.renderer.addClass(this.el.nativeElement, this.notIosWebClassName);
    }
  }

  ngOnDestroy() {
    if (this.touchendTimer) {
      clearTimeout(this.touchendTimer);
    }
    if (this.touchcancelTimer) {
      clearTimeout(this.touchcancelTimer);
    }
  }
}
